import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useEntrySheetFormatData } from '@/composables/format-edit/useEntrySheetHistories'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntrySheetTextFieldCard',
  props: {
    cardId: null,
    currentCardId: null,
    title: null,
    description: null,
    fieldKey: null,
    errorKey: null,
    previewErrors: null,
    textareaMinRows: null,
    inputClass: null
  },
  setup(__props: any) {

const props = __props as {
  cardId: string
  currentCardId?: string
  title: string
  description: string
  fieldKey: string
  errorKey: string
  previewErrors: Record<string, string>
  textareaMinRows?: number
  inputClass?: string
};



const formatData = useEntrySheetFormatData() as Record<string, unknown>

const fieldValue = computed(() => String(formatData[props.fieldKey] ?? ''))
const hasError = computed(() => !!props.previewErrors[props.errorKey])
const textareaMinRows = computed(() => props.textareaMinRows ?? 3)

function onInput(value: string) {
  formatData[props.fieldKey] = value
}

return { __sfc: true,props, formatData, fieldValue, hasError, textareaMinRows, onInput }
}

})